exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1929d2c4] .table-full .v-datatable.v-table>tbody{max-height:none!important;min-height:0!important}.expandableCon[data-v-1929d2c4]{border:1px solid red!important;width:300px}", ""]);

// exports
